import { FilePdfOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostDataNU, nufileDownload } from 'services/nezarazenyUcet/nuDedictvi';

interface IVypisPrehled {
    zadostData?: IZadostDataNU;
    stav: string;
}

const Prehled: React.FC<IVypisPrehled> = props => {
    const { zadostData, stav } = props;
    const history = useHistory();
    const [errStatus, setErrStatus] = useState<number>();
    const { token } = useParams<{ token: string }>(); // Bank ID token sebran z urlky
    const [loading, setLoading] = useState<boolean>(false);

    const routeChangeLoginPage = () => {
        let path = zadostData?.idzadosti
            ? '/nezarazeny-ucet-zjisteni/bankid/' + zadostData.idzadosti
            : '/nezarazeny-ucet-zjisteni/bankid';
        history.push(path);
    };

    const routeChange = () => {
        let path = '/siroka-verejnost/sluzby-pro-sirokou-verejnost/';
        window.open(path, '_parent');
    };

    const vypisDownload = () => {
        setLoading(true);
        nufileDownload('pdf', token, 'vypis')
            .then(() => {
                setLoading(false);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    const fakturaDownload = () => {
        setLoading(true);
        nufileDownload('pdf', token, 'faktura')
            .then(() => {
                setLoading(false);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChangeLoginPage} />
                    </Row>
                </Col>
            ) : stav ? (
                <>
                    <h1>
                        <TranslateText>STAV_NADPIS</TranslateText>
                    </h1>
                    <div>
                        {stav === 'CEKA' ? ( // Stav CEKA
                            <>
                                <Row>
                                    <Paragraph text="STAV_CEKA_NU" />
                                </Row>
                                <Row>
                                    <Paragraph text="STAV_CEKA_NU2" />
                                </Row>
                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="OK" onClick={routeChange} />
                                </Row>
                            </>
                        ) : stav === 'DUPL' ? ( // Stav DUPL
                            <>
                                <Paragraph text="STAV_DUPL" />

                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="OK" onClick={routeChange} />
                                </Row>
                            </>
                        ) : stav === 'ZPRAC' ? ( // Stav ZPRAC
                            <>
                                <Row>
                                    <Col span={24} className="detail">
                                        <TranslateText>STAV_ZPRAC_NU_1</TranslateText>{' '}
                                        <TranslateText>{moment(zadostData?.datum).format('DD.MM.YYYY')}</TranslateText>.
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span={24} className="detail">
                                        <TranslateText>STAV_ZPRAC_NU_2</TranslateText>
                                    </Col>
                                </Row>

                                <LoadingWrapper loading={loading} download={true}>
                                    <div className="files">
                                        <Row className="file-row" align="middle">
                                            <Col span={1} className="file-detail" onClick={vypisDownload}>
                                                <FilePdfOutlined />
                                            </Col>
                                            <Col span={11} className="file-detail" onClick={vypisDownload}>
                                                <Paragraph text="Zjištění majetkového účtu.pdf" strong={true} />
                                            </Col>
                                            <Col span={10}>
                                                <></>
                                            </Col>
                                        </Row>

                                        <Row className="file-row" align="middle">
                                            <Col span={1} className="file-detail" onClick={fakturaDownload}>
                                                <FilePdfOutlined />
                                            </Col>
                                            <Col span={11} className="file-detail" onClick={fakturaDownload}>
                                                <Paragraph text="Faktura.pdf" strong={true} />
                                            </Col>
                                            <Col span={10}>
                                                <></>
                                            </Col>
                                        </Row>
                                    </div>
                                </LoadingWrapper>
                            </>
                        ) : stav === 'VYPR' ? ( // Stav VYPR
                            <>
                                <Paragraph text="STAV_VYPR" />

                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="OK" onClick={routeChange} />
                                </Row>
                            </>
                        ) : null}
                    </div>
                </>
            ) : (
                <>
                    <h1>
                        <TranslateText>STAV_NADPIS</TranslateText>
                    </h1>
                    <TranslateText>NEZNAMY_STAV</TranslateText>
                </>
            )}
        </>
    );
};

export default Prehled;
